// =============================
// AboutPro.jsx (compact, professional)
// =============================
import React from "react";
import "./Stylesheets/About.css";

/**
 * OFEAA — About (compact, minimal)
 * Props (optional):
 * - constitutionUrl: string
 * - applicationUrl: string
 */
export default function AboutPro({
  constitutionUrl = "#",
  applicationUrl = "#",
}) {
  const objectives = [
    "Direct attention of government agencies and the public to members’ activities in producing aquaculture products for human consumption and recreation.",
    "Develop programs that promote member objectives.",
    "Advance an environmentally responsible aquaculture industry in Ontario.",
    "Create educational and support programs for aquaculturists.",
    "Establish programs that address fish stocking.",
    "Promote quality control guidelines and standards for Ontario farm-raised fish.",
    "Represent members in negotiations with government and other agencies.",
    "Keep members informed with pertinent information.",
    "Coordinate advertising, exhibitions, and other initiatives that further the industry.",
    "Revise and expand objectives as necessary.",
  ];

  return (
    <section className="ofeaa-pro" aria-label="Ontario Fishery Enhancement and Aquaculture Association">
      {/* Compact masthead */}
      <header className="ofeaa-pro__hero">
        <div className="ofeaa-pro__hero-inner">
          <h1 className="ofeaa-pro__title">
            Ontario Fishery Enhancement & Aquaculture Association
          </h1>
          <p className="ofeaa-pro__subtitle">
            Representing land-based aquaculturists, pond and land owners, and stakeholders committed to responsible cultivation and stocking of fish across Ontario.
          </p>

          <div className="ofeaa-pro__cta">
            <a className="ofeaa-pro__btn" href={constitutionUrl}>View Constitution</a>
            <a className="ofeaa-pro__btn ofeaa-pro__btn--ghost" href={applicationUrl}>Membership Application</a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="ofeaa-pro__container">
        <div className="ofeaa-pro__grid">
          <section className="ofeaa-pro__card">
            <h2 className="ofeaa-pro__h2">About Us</h2>
            <p className="ofeaa-pro__body">
              The Ontario Fishery Enhancement and Aquaculture Association brings together land-based aquaculturists,
              pond owners, and land owners who manage waters on their land, along with cottage associations and other
              stakeholders interested in culturing and stocking fish in Ontario.
            </p>
            <div className="ofeaa-pro__downloads">
              <a className="ofeaa-pro__chip" href={constitutionUrl}>Constitution</a>
              <a className="ofeaa-pro__chip" href={applicationUrl}>Application</a>
            </div>
          </section>

          <section className="ofeaa-pro__card">
            <h2 className="ofeaa-pro__h2">Objectives</h2>
            <ul className="ofeaa-pro__list" role="list">
              {objectives.map((t, i) => (
                <li key={i} className="ofeaa-pro__list-item">
                  <span className="ofeaa-pro__dot" aria-hidden="true" />
                  <span className="ofeaa-pro__list-text">{t}</span>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </main>
    </section>
  );
}
